export default __webpack_public_path__ + "static/AudioOverlays-35100e001d2a6e4d1b3f999e5d536c6d.png";